import { API_TYPE } from '@umu/umu-fetch';
const BASE_API = '/uapi/v1';
const AI_TALENT_API = `${BASE_API}/caet`;
/**
 * @description: AI力认证证书API
 * @author: wyf
 * @API: https://yapi.umu.work/project/834/interface/api/cat_1859
 */
const API = {
    // 领取证书
    RECEIVE_CERTIFICATE: {
        url: `${AI_TALENT_API}/receive-certificate`,
        type: API_TYPE.POST,
    },
    // AI 力证书列表
    CERTIFICATE_LIST: {
        url: `${AI_TALENT_API}/certificate-list`,
        type: API_TYPE.GET,
    },
    // 推荐课程列表
    RECOMMENDED_COURSE_LIST: {
        url: `${AI_TALENT_API}/recommended-list`,
        type: API_TYPE.GET,
    },
    // 设置证书信息
    SET_CERTIFICATE_SETTING: {
        url: `${AI_TALENT_API}/set-certificate-setting`,
        type: API_TYPE.POST,
    },
    // 设置证书权限
    SET_CERTIFICATE_PERMISSION: {
        url: `${AI_TALENT_API}/set-certificate-permission`,
        type: API_TYPE.POST,
    },
    // 证书详情
    GET_CERTIFICATE: {
        url: `${AI_TALENT_API}/get-certificate`,
        type: API_TYPE.GET,
    },
    // 获取设置证书信息
    GET_CERTIFICATE_SETTING: {
        url: `${AI_TALENT_API}/get-certificate-setting`,
        type: API_TYPE.GET,
    },
    // 获取资源对应的证书信息
    GET_RESOURCE_CERTIFICATE: {
        url: `${AI_TALENT_API}/my-certificate`,
        type: API_TYPE.GET,
    },
    // 获取证书配置信息
    GET_RESOURCE_CONFIG: {
        url: '/napi/v1/caet/obj-info',
        type: API_TYPE.GET,
    },
    // 获取 AI 力证书配置
    GET_CAET_CONFIG: {
        url: `${AI_TALENT_API}/get-config`,
        type: API_TYPE.GET,
    },
};
export { API };
